import { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { ArrowRight, Lock } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Logo } from "@/components/Navbar";
import { useAuth, formatApiError } from "@/lib/auth";

const inputCls =
  "h-12 rounded-none border-white/10 bg-white/5 text-sm text-stone-100 placeholder:text-stone-500 focus-visible:ring-0 focus-visible:border-brand/60";

const AdminLogin = () => {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [sending, setSending] = useState(false);

  if (user) return <Navigate to={location.state?.from?.pathname || "/admin/imoveis"} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSending(true);
    try {
      await login(email, password);
      navigate(location.state?.from?.pathname || "/admin/imoveis", { replace: true });
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-obsidian px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md border border-white/10 bg-coal p-8 sm:p-10">
        <Logo />
        <p className="mt-8 flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.35em] text-brand">
          <Lock size={12} /> Área restrita
        </p>
        <h1 className="mt-3 font-serif text-2xl text-[#F4F4F6] sm:text-3xl">Entrar no painel</h1>
        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="admin-login-form">
          <Input required type="email" placeholder="E-mail" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} data-testid="admin-login-email" />
          <Input required type="password" placeholder="Senha" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} data-testid="admin-login-password" />
          {error && (
            <p className="border border-brand/40 bg-brand/10 px-4 py-3 text-sm text-brand-light" data-testid="admin-login-error">{error}</p>
          )}
          <button
            type="submit"
            disabled={sending}
            data-testid="admin-login-submit"
            className="group inline-flex w-full items-center justify-center gap-3 bg-brand px-8 py-4 font-mono text-[11px] uppercase tracking-[0.25em] text-white transition-colors duration-300 hover:bg-brand-light disabled:opacity-60"
          >
            {sending ? "Entrando..." : "Entrar"}
            <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
